import { Checkbox } from "@/components/ui/checkbox";
import { StepHeader } from "@/components/apply/Field";
import { Captcha } from "@/components/Captcha";
import { CashNotice } from "@/components/site/CashNotice";
import { useSiteSettings } from "@/context/SettingsContext";
import { money } from "@/lib/api";
import { ADDON_LABELS } from "@/data/options";

const AGREEMENTS = [
  ["accurate", "I confirm all information I've provided is accurate and truthful."],
  ["interview_consent", "I consent to a Zoom video interview as part of the vetting process."],
  ["cash_policy", "I understand membership is paid in cash only after approval, and I accept the refund policy: [Refund policy placeholder]."],
];

const Block = ({ title, rows }) => (
  <div className="rounded-2xl border border-border bg-card p-5">
    <p className="eyebrow text-muted-foreground mb-3">{title}</p>
    <dl className="grid gap-2 text-sm">
      {rows.map(([k, v]) => (
        <div key={k} className="flex justify-between gap-4"><dt className="text-muted-foreground">{k}</dt><dd className="font-semibold text-right break-all">{v || "-"}</dd></div>
      ))}
    </dl>
  </div>
);

export const StepReview = ({ form, setForm, captcha, setCaptcha, nonce }) => {
  const { settings } = useSiteSettings();
  const tier = settings?.tiers.find((t) => t.key === form.tier);
  const { contact: c, profile: p } = form;
  const setAgree = (k) => (v) => setForm((f) => ({ ...f, agreements: { ...f.agreements, [k]: !!v } }));
  return (
    <div data-testid="step-review">
      <StepHeader title="Review & submit" text="Double-check everything before sending." />
      <div className="grid gap-4 md:grid-cols-2">
        <Block title="Contact" rows={[["Name", c.full_name], ["Email", c.email], ["Phone", `${c.phone_code} ${c.phone}`], ["Location", `${c.city}, ${c.country}`], ["Time zone", c.timezone]]} />
        <Block title="Buyer profile" rows={[["Business", p.business_name], ["Category", p.category], ["Monthly volume", p.monthly_volume], ["Years", p.years_in_business], ["Heard via", p.heard_about]]} />
        <Block title="Membership" rows={[["Tier", tier ? `${tier.name} · ${money(tier.price)}` : ""], ["Add-ons", form.addons.map((a) => ADDON_LABELS[a]).join(", ") || "None"]]} />
        <Block title="ID & interview" rows={[["Documents", `${Object.values(form.files).filter(Boolean).length}/3 uploaded`], ...form.interview_slots.map((s, i) => [`Option ${i + 1}`, s.replace("T", " ")])]} />
      </div>
      <div className="mt-6 space-y-3">
        {AGREEMENTS.map(([k, label]) => (
          <label key={k} className="flex items-start gap-3 cursor-pointer rounded-xl p-3 hover:bg-secondary transition-colors">
            <Checkbox className="mt-0.5" checked={form.agreements[k]} onCheckedChange={setAgree(k)} data-testid={`apply-agree-${k}`} />
            <span className="text-sm">{label}</span>
          </label>
        ))}
      </div>
      <div className="mt-6 space-y-4">
        <Captcha value={captcha} onChange={setCaptcha} nonce={nonce} testPrefix="apply-captcha" />
        <CashNotice testId="apply-review-cash-notice" />
      </div>
    </div>
  );
};
